module.exports = __webpack_public_path__ + "static/media/MQ.61a53cf5.svg";